import { api } from '@/services/api/main/axios';
import { useWorkspace } from '@/composables/useWorkspace';

export const getFlowsApiRequest = async (
  params: Record<string, unknown> = {},
): Promise<unknown[]> => {
  const res = await api.get<{ payload: unknown[] }>('flows', { params });
  return res.data.payload;
};

export type GetFlowsListParams = {
  search?: string;
  status?: string;
  limit?: string | number;
  orderBy?: string;
  orderDirection?: string;
  columns?: string[];
  countryId?: number;
  workspaceId?: string;
};

export const getFlowsListApiRequest = async (
  params: GetFlowsListParams,
): Promise<unknown[]> => {
  const { workspaceId, ...rest } = params;
  const workspaceApi = useWorkspace();
  const requestParams: Record<string, unknown> = {
    ...rest,
    workspaceIds: [...new Set([workspaceId, ...workspaceApi.allPublicWorkspacesIds.value])],
  };
  return getFlowsApiRequest(requestParams);
};

export const getFlowApiRequest = async (id: string): Promise<Record<string, unknown>> => {
  const res = await api.get<{ payload: Record<string, unknown> }>(`flows/${id}`);
  return res.data.payload;
};

export const postCreateFlowApiRequest = async (
  payload: object,
): Promise<Record<string, unknown>> => {
  const res = await api.post<{ payload: Record<string, unknown> }>('flows', payload);
  return res.data.payload;
};

export const putUpdateFlowApiRequest = async (
  id: string,
  payload: object,
): Promise<Record<string, unknown>> => {
  const res = await api.put<{ payload: Record<string, unknown> }>(`flows/${id}`, payload);
  return res.data.payload;
};
